function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _class, _retryDelayIterator, _temp;

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

var BasePlugin = require('@uppy/core/lib/BasePlugin');

var tus = require('tus-js-client');

var _require = require('@uppy/companion-client'),
    Provider = _require.Provider,
    RequestClient = _require.RequestClient,
    Socket = _require.Socket;

var emitSocketProgress = require('@uppy/utils/lib/emitSocketProgress');

var getSocketHost = require('@uppy/utils/lib/getSocketHost');

var settle = require('@uppy/utils/lib/settle');

var EventTracker = require('@uppy/utils/lib/EventTracker');

var NetworkError = require('@uppy/utils/lib/NetworkError');

var isNetworkError = require('@uppy/utils/lib/isNetworkError');

var _require2 = require('@uppy/utils/lib/RateLimitedQueue'),
    RateLimitedQueue = _require2.RateLimitedQueue;

var hasProperty = require('@uppy/utils/lib/hasProperty');

var getFingerprint = require('./getFingerprint');
/** @typedef {import('..').TusOptions} TusOptions */

/** @typedef {import('tus-js-client').UploadOptions} RawTusOptions */

/** @typedef {import('@uppy/core').Uppy} Uppy */

/** @typedef {import('@uppy/core').UppyFile} UppyFile */

/** @typedef {import('@uppy/core').FailedUppyFile<{}>} FailedUppyFile */

/**
 * Extracted from https://github.com/tus/tus-js-client/blob/master/lib/upload.js#L13
 * excepted we removed 'fingerprint' key to avoid adding more dependencies
 *
 * @type {RawTusOptions}
 */


var tusDefaultOptions = {
  endpoint: '',
  uploadUrl: null,
  metadata: {},
  uploadSize: null,
  onProgress: null,
  onChunkComplete: null,
  onSuccess: null,
  onError: null,
  overridePatchMethod: false,
  headers: {},
  addRequestId: false,
  chunkSize: Infinity,
  retryDelays: [100, 1000, 3000, 5000],
  parallelUploads: 1,
  removeFingerprintOnSuccess: false,
  uploadLengthDeferred: false,
  uploadDataDuringCreation: false
};
/**
 * Tus resumable file uploader
 */

module.exports = (_temp = (_retryDelayIterator = /*#__PURE__*/_classPrivateFieldLooseKey("retryDelayIterator"), _class = /*#__PURE__*/function (_BasePlugin) {
  _inherits(Tus, _BasePlugin);

  var _super = _createSuper(Tus);

  // eslint-disable-next-line global-require

  /**
   * @param {Uppy} uppy
   * @param {TusOptions} opts
   */
  function Tus(uppy, opts) {
    var _this;

    _classCallCheck(this, Tus);

    var _this$opts$retryDelay;

    _this = _super.call(this, uppy, opts);
    Object.defineProperty(_assertThisInitialized(_this), _retryDelayIterator, {
      writable: true,
      value: void 0
    });
    _this.type = 'uploader';
    _this.id = _this.opts.id || 'Tus';
    _this.title = 'Tus'; // set default options

    var defaultOptions = {
      useFastRemoteRetry: true,
      limit: 20,
      retryDelays: tusDefaultOptions.retryDelays,
      withCredentials: false
    }; // merge default options with the ones set by user

    /** @type {import("..").TusOptions} */

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts);

    if ('autoRetry' in opts) {
      throw new Error('The `autoRetry` option was deprecated and has been removed.');
    }
    /**
     * Simultaneous upload limiting is shared across all uploads with this plugin.
     *
     * @type {RateLimitedQueue}
     */


    _this.requests = new RateLimitedQueue(_this.opts.limit);
    _classPrivateFieldLooseBase(_assertThisInitialized(_this), _retryDelayIterator)[_retryDelayIterator] = (_this$opts$retryDelay = _this.opts.retryDelays) == null ? void 0 : _this$opts$retryDelay.values();
    _this.uploaders = Object.create(null);
    _this.uploaderEvents = Object.create(null);
    _this.uploaderSockets = Object.create(null);
    _this.handleResetProgress = _this.handleResetProgress.bind(_assertThisInitialized(_this));
    _this.handleUpload = _this.handleUpload.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Tus, [{
    key: "handleResetProgress",
    value: function handleResetProgress() {
      var files = _objectSpread({}, this.uppy.getState().files);

      Object.keys(files).forEach(function (fileID) {
        // Only clone the file object if it has a Tus `uploadUrl` attached.
        if (files[fileID].tus && files[fileID].tus.uploadUrl) {
          var tusState = _objectSpread({}, files[fileID].tus);

          delete tusState.uploadUrl;
          files[fileID] = _objectSpread(_objectSpread({}, files[fileID]), {}, {
            tus: tusState
          });
        }
      });
      this.uppy.setState({
        files: files
      });
    }
    /**
     * Clean up all references for a file's upload: the tus.Upload instance,
     * any events related to the file, and the Companion WebSocket connection.
     *
     * @param {string} fileID
     */

  }, {
    key: "resetUploaderReferences",
    value: function resetUploaderReferences(fileID, opts) {
      if (opts === void 0) {
        opts = {};
      }

      if (this.uploaders[fileID]) {
        var uploader = this.uploaders[fileID];
        uploader.abort();

        if (opts.abort) {
          uploader.abort(true);
        }

        this.uploaders[fileID] = null;
      }

      if (this.uploaderEvents[fileID]) {
        this.uploaderEvents[fileID].remove();
        this.uploaderEvents[fileID] = null;
      }

      if (this.uploaderSockets[fileID]) {
        this.uploaderSockets[fileID].close();
        this.uploaderSockets[fileID] = null;
      }
    }
    /**
     * Create a new Tus upload.
     *
     * A lot can happen during an upload, so this is quite hard to follow!
     * - First, the upload is started. If the file was already paused by the time the upload starts, nothing should happen.
     *   If the `limit` option is used, the upload must be queued onto the `this.requests` queue.
     *   When an upload starts, we store the tus.Upload instance, and an EventTracker instance that manages the event listeners
     *   for pausing, cancellation, removal, etc.
     * - While the upload is in progress, it may be paused or cancelled.
     *   Pausing aborts the underlying tus.Upload, and removes the upload from the `this.requests` queue. All other state is
     *   maintained.
     *   Cancelling removes the upload from the `this.requests` queue, and completely aborts the upload-- the `tus.Upload`
     *   instance is aborted and discarded, the EventTracker instance is destroyed (removing all listeners).
     *   Resuming the upload uses the `this.requests` queue as well, to prevent selectively pausing and resuming uploads from
     *   bypassing the limit.
     * - After completing an upload, the tus.Upload and EventTracker instances are cleaned up, and the upload is marked as done
     *   in the `this.requests` queue.
     * - When an upload completed with an error, the same happens as on successful completion, but the `upload()` promise is
     *   rejected.
     *
     * When working on this function, keep in mind:
     *  - When an upload is completed or cancelled for any reason, the tus.Upload and EventTracker instances need to be cleaned
     *    up using this.resetUploaderReferences().
     *  - When an upload is cancelled or paused, for any reason, it needs to be removed from the `this.requests` queue using
     *    `queuedRequest.abort()`.
     *  - When an upload is completed for any reason, including errors, it needs to be marked as such using
     *    `queuedRequest.done()`.
     *  - When an upload is started or resumed, it needs to go through the `this.requests` queue. The `queuedRequest` variable
     *    must be updated so the other uses of it are valid.
     *  - Before replacing the `queuedRequest` variable, the previous `queuedRequest` must be aborted, else it will keep taking
     *    up a spot in the queue.
     *
     * @param {UppyFile} file for use with upload
     * @param {number} current file in a queue
     * @param {number} total number of files in a queue
     * @returns {Promise<void>}
     */

  }, {
    key: "upload",
    value: function upload(file) {
      var _this2 = this;

      this.resetUploaderReferences(file.id); // Create a new tus upload

      return new Promise(function (resolve, reject) {
        var queuedRequest;
        var qRequest;

        _this2.uppy.emit('upload-started', file);

        var opts = _objectSpread(_objectSpread({}, _this2.opts), file.tus || {});

        if (typeof opts.headers === 'function') {
          opts.headers = opts.headers(file);
        }
        /** @type {RawTusOptions} */


        var uploadOptions = _objectSpread(_objectSpread({}, tusDefaultOptions), opts); // We override tus fingerprint to uppy’s `file.id`, since the `file.id`
        // now also includes `relativePath` for files added from folders.
        // This means you can add 2 identical files, if one is in folder a,
        // the other in folder b.


        uploadOptions.fingerprint = getFingerprint(file);

        uploadOptions.onBeforeRequest = function (req) {
          var xhr = req.getUnderlyingObject();
          xhr.withCredentials = !!opts.withCredentials;

          if (typeof opts.onBeforeRequest === 'function') {
            opts.onBeforeRequest(req);
          }

          if (hasProperty(queuedRequest, 'shouldBeRequeued')) {
            if (!queuedRequest.shouldBeRequeued) return Promise.reject();
            var done;
            var p = new Promise(function (res) {
              // eslint-disable-line promise/param-names
              done = res;
            });
            queuedRequest = _this2.requests.run(function () {
              if (file.isPaused) {
                queuedRequest.abort();
              }

              done();
              return function () {};
            });
            return p;
          }

          return undefined;
        };

        uploadOptions.onError = function (err) {
          _this2.uppy.log(err);

          var xhr = err.originalRequest ? err.originalRequest.getUnderlyingObject() : null;

          if (isNetworkError(xhr)) {
            err = new NetworkError(err, xhr);
          }

          _this2.resetUploaderReferences(file.id);

          queuedRequest.abort();

          _this2.uppy.emit('upload-error', file, err);

          reject(err);
        };

        uploadOptions.onProgress = function (bytesUploaded, bytesTotal) {
          _this2.onReceiveUploadUrl(file, upload.url);

          _this2.uppy.emit('upload-progress', file, {
            uploader: _this2,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
          });
        };

        uploadOptions.onSuccess = function () {
          var uploadResp = {
            uploadURL: upload.url
          };

          _this2.resetUploaderReferences(file.id);

          queuedRequest.done();

          _this2.uppy.emit('upload-success', file, uploadResp);

          if (upload.url) {
            _this2.uppy.log("Download ".concat(upload.file.name, " from ").concat(upload.url));
          }

          resolve(upload);
        };

        uploadOptions.onShouldRetry = function (err) {
          var _err$originalResponse;

          var status = err == null ? void 0 : (_err$originalResponse = err.originalResponse) == null ? void 0 : _err$originalResponse.getStatus();

          if (status === 429) {
            // HTTP 429 Too Many Requests => to avoid the whole download to fail, pause all requests.
            if (!_this2.requests.isPaused) {
              var _classPrivateFieldLoo;

              var next = (_classPrivateFieldLoo = _classPrivateFieldLooseBase(_this2, _retryDelayIterator)[_retryDelayIterator]) == null ? void 0 : _classPrivateFieldLoo.next();

              if (next == null || next.done) {
                return false;
              }

              _this2.requests.rateLimit(next.value);
            }
          } else if (status > 400 && status < 500 && status !== 409) {
            // HTTP 4xx, the server won't send anything, it's doesn't make sense to retry
            return false;
          } else if (typeof navigator !== 'undefined' && navigator.onLine === false) {
            // The navigator is offline, let's wait for it to come back online.
            if (!_this2.requests.isPaused) {
              _this2.requests.pause();

              window.addEventListener('online', function () {
                _this2.requests.resume();
              }, {
                once: true
              });
            }
          }

          queuedRequest.abort();
          queuedRequest = {
            shouldBeRequeued: true,
            abort: function abort() {
              this.shouldBeRequeued = false;
            },
            done: function done() {
              throw new Error('Cannot mark a queued request as done: this indicates a bug');
            },
            fn: function fn() {
              throw new Error('Cannot run a queued request: this indicates a bug');
            }
          };
          return true;
        };

        var copyProp = function copyProp(obj, srcProp, destProp) {
          if (hasProperty(obj, srcProp) && !hasProperty(obj, destProp)) {
            obj[destProp] = obj[srcProp];
          }
        };
        /** @type {Record<string, string>} */


        var meta = {};
        var metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
        : Object.keys(file.meta);
        metaFields.forEach(function (item) {
          meta[item] = file.meta[item];
        }); // tusd uses metadata fields 'filetype' and 'filename'

        copyProp(meta, 'type', 'filetype');
        copyProp(meta, 'name', 'filename');
        uploadOptions.metadata = meta;
        var upload = new tus.Upload(file.data, uploadOptions);
        _this2.uploaders[file.id] = upload;
        _this2.uploaderEvents[file.id] = new EventTracker(_this2.uppy); // eslint-disable-next-line prefer-const

        qRequest = function qRequest() {
          if (!file.isPaused) {
            upload.start();
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.


          return function () {};
        };

        upload.findPreviousUploads().then(function (previousUploads) {
          var previousUpload = previousUploads[0];

          if (previousUpload) {
            _this2.uppy.log("[Tus] Resuming upload of ".concat(file.id, " started at ").concat(previousUpload.creationTime));

            upload.resumeFromPreviousUpload(previousUpload);
          }
        });
        queuedRequest = _this2.requests.run(qRequest);

        _this2.onFileRemove(file.id, function (targetFileID) {
          queuedRequest.abort();

          _this2.resetUploaderReferences(file.id, {
            abort: !!upload.url
          });

          resolve("upload ".concat(targetFileID, " was removed"));
        });

        _this2.onPause(file.id, function (isPaused) {
          queuedRequest.abort();

          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            upload.abort();
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest = _this2.requests.run(qRequest);
          }
        });

        _this2.onPauseAll(file.id, function () {
          queuedRequest.abort();
          upload.abort();
        });

        _this2.onCancelAll(file.id, function () {
          queuedRequest.abort();

          _this2.resetUploaderReferences(file.id, {
            abort: !!upload.url
          });

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this2.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            upload.abort();
          }

          queuedRequest = _this2.requests.run(qRequest);
        });
      }).catch(function (err) {
        _this2.uppy.emit('upload-error', file, err);

        throw err;
      });
    }
    /**
     * @param {UppyFile} file for use with upload
     * @param {number} current file in a queue
     * @param {number} total number of files in a queue
     * @returns {Promise<void>}
     */

  }, {
    key: "uploadRemote",
    value: function uploadRemote(file) {
      var _this3 = this;

      this.resetUploaderReferences(file.id);

      var opts = _objectSpread({}, this.opts);

      if (file.tus) {
        // Install file-specific upload overrides.
        Object.assign(opts, file.tus);
      }

      this.uppy.emit('upload-started', file);
      this.uppy.log(file.remote.url);

      if (file.serverToken) {
        return this.connectToServerSocket(file);
      }

      return new Promise(function (resolve, reject) {
        var Client = file.remote.providerOptions.provider ? Provider : RequestClient;
        var client = new Client(_this3.uppy, file.remote.providerOptions); // !! cancellation is NOT supported at this stage yet

        client.post(file.remote.url, _objectSpread(_objectSpread({}, file.remote.body), {}, {
          endpoint: opts.endpoint,
          uploadUrl: opts.uploadUrl,
          protocol: 'tus',
          size: file.data.size,
          headers: opts.headers,
          metadata: file.meta
        })).then(function (res) {
          _this3.uppy.setFileState(file.id, {
            serverToken: res.token
          });

          file = _this3.uppy.getFile(file.id);
          return _this3.connectToServerSocket(file);
        }).then(function () {
          resolve();
        }).catch(function (err) {
          _this3.uppy.emit('upload-error', file, err);

          reject(err);
        });
      });
    }
    /**
     * See the comment on the upload() method.
     *
     * Additionally, when an upload is removed, completed, or cancelled, we need to close the WebSocket connection. This is
     * handled by the resetUploaderReferences() function, so the same guidelines apply as in upload().
     *
     * @param {UppyFile} file
     */

  }, {
    key: "connectToServerSocket",
    value: function connectToServerSocket(file) {
      var _this4 = this;

      return new Promise(function (resolve, reject) {
        var token = file.serverToken;
        var host = getSocketHost(file.remote.companionUrl);
        var socket = new Socket({
          target: "".concat(host, "/api/").concat(token),
          autoOpen: false
        });
        _this4.uploaderSockets[file.id] = socket;
        _this4.uploaderEvents[file.id] = new EventTracker(_this4.uppy);
        var queuedRequest;

        _this4.onFileRemove(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});

          _this4.resetUploaderReferences(file.id);

          resolve("upload ".concat(file.id, " was removed"));
        });

        _this4.onPause(file.id, function (isPaused) {
          if (isPaused) {
            // Remove this file from the queue so another file can start in its place.
            queuedRequest.abort();
            socket.send('pause', {});
          } else {
            // Resuming an upload should be queued, else you could pause and then
            // resume a queued upload to make it skip the queue.
            queuedRequest.abort();
            queuedRequest = _this4.requests.run(function () {
              socket.send('resume', {});
              return function () {};
            });
          }
        });

        _this4.onPauseAll(file.id, function () {
          queuedRequest.abort();
          socket.send('pause', {});
        });

        _this4.onCancelAll(file.id, function () {
          queuedRequest.abort();
          socket.send('cancel', {});

          _this4.resetUploaderReferences(file.id);

          resolve("upload ".concat(file.id, " was canceled"));
        });

        _this4.onResumeAll(file.id, function () {
          queuedRequest.abort();

          if (file.error) {
            socket.send('pause', {});
          }

          queuedRequest = _this4.requests.run(function () {
            socket.send('resume', {});
            return function () {};
          });
        });

        _this4.onRetry(file.id, function () {
          // Only do the retry if the upload is actually in progress;
          // else we could try to send these messages when the upload is still queued.
          // We may need a better check for this since the socket may also be closed
          // for other reasons, like network failures.
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        _this4.onRetryAll(file.id, function () {
          // See the comment in the onRetry() call
          if (socket.isOpen) {
            socket.send('pause', {});
            socket.send('resume', {});
          }
        });

        socket.on('progress', function (progressData) {
          return emitSocketProgress(_this4, progressData, file);
        });
        socket.on('error', function (errData) {
          var message = errData.error.message;
          var error = Object.assign(new Error(message), {
            cause: errData.error
          }); // If the remote retry optimisation should not be used,
          // close the socket—this will tell companion to clear state and delete the file.

          if (!_this4.opts.useFastRemoteRetry) {
            _this4.resetUploaderReferences(file.id); // Remove the serverToken so that a new one will be created for the retry.


            _this4.uppy.setFileState(file.id, {
              serverToken: null
            });
          } else {
            socket.close();
          }

          _this4.uppy.emit('upload-error', file, error);

          queuedRequest.done();
          reject(error);
        });
        socket.on('success', function (data) {
          var uploadResp = {
            uploadURL: data.url
          };

          _this4.uppy.emit('upload-success', file, uploadResp);

          _this4.resetUploaderReferences(file.id);

          queuedRequest.done();
          resolve();
        });
        queuedRequest = _this4.requests.run(function () {
          socket.open();

          if (file.isPaused) {
            socket.send('pause', {});
          } // Don't do anything here, the caller will take care of cancelling the upload itself
          // using resetUploaderReferences(). This is because resetUploaderReferences() has to be
          // called when this request is still in the queue, and has not been started yet, too. At
          // that point this cancellation function is not going to be called.
          // Also, we need to remove the request from the queue _without_ destroying everything
          // related to this upload to handle pauses.


          return function () {};
        });
      });
    }
    /**
     * Store the uploadUrl on the file options, so that when Golden Retriever
     * restores state, we will continue uploading to the correct URL.
     *
     * @param {UppyFile} file
     * @param {string} uploadURL
     */

  }, {
    key: "onReceiveUploadUrl",
    value: function onReceiveUploadUrl(file, uploadURL) {
      var currentFile = this.uppy.getFile(file.id);
      if (!currentFile) return; // Only do the update if we didn't have an upload URL yet.

      if (!currentFile.tus || currentFile.tus.uploadUrl !== uploadURL) {
        this.uppy.log('[Tus] Storing upload url');
        this.uppy.setFileState(currentFile.id, {
          tus: _objectSpread(_objectSpread({}, currentFile.tus), {}, {
            uploadUrl: uploadURL
          })
        });
      }
    }
    /**
     * @param {string} fileID
     * @param {function(string): void} cb
     */

  }, {
    key: "onFileRemove",
    value: function onFileRemove(fileID, cb) {
      this.uploaderEvents[fileID].on('file-removed', function (file) {
        if (fileID === file.id) cb(file.id);
      });
    }
    /**
     * @param {string} fileID
     * @param {function(boolean): void} cb
     */

  }, {
    key: "onPause",
    value: function onPause(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-pause', function (targetFileID, isPaused) {
        if (fileID === targetFileID) {
          // const isPaused = this.uppy.pauseResume(fileID)
          cb(isPaused);
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onRetry",
    value: function onRetry(fileID, cb) {
      this.uploaderEvents[fileID].on('upload-retry', function (targetFileID) {
        if (fileID === targetFileID) {
          cb();
        }
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onRetryAll",
    value: function onRetryAll(fileID, cb) {
      var _this5 = this;

      this.uploaderEvents[fileID].on('retry-all', function () {
        if (!_this5.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onPauseAll",
    value: function onPauseAll(fileID, cb) {
      var _this6 = this;

      this.uploaderEvents[fileID].on('pause-all', function () {
        if (!_this6.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onCancelAll",
    value: function onCancelAll(fileID, cb) {
      var _this7 = this;

      this.uploaderEvents[fileID].on('cancel-all', function () {
        if (!_this7.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {string} fileID
     * @param {function(): void} cb
     */

  }, {
    key: "onResumeAll",
    value: function onResumeAll(fileID, cb) {
      var _this8 = this;

      this.uploaderEvents[fileID].on('resume-all', function () {
        if (!_this8.uppy.getFile(fileID)) return;
        cb();
      });
    }
    /**
     * @param {(UppyFile | FailedUppyFile)[]} files
     */

  }, {
    key: "uploadFiles",
    value: function uploadFiles(files) {
      var _this9 = this;

      var promises = files.map(function (file, i) {
        var current = i + 1;
        var total = files.length;

        if ('error' in file && file.error) {
          return Promise.reject(new Error(file.error));
        }

        if (file.isRemote) {
          // We emit upload-started here, so that it's also emitted for files
          // that have to wait due to the `limit` option.
          // Don't double-emit upload-started for Golden Retriever-restored files that were already started
          if (!file.progress.uploadStarted || !file.isRestored) {
            _this9.uppy.emit('upload-started', file);
          }

          return _this9.uploadRemote(file, current, total);
        } // Don't double-emit upload-started for Golden Retriever-restored files that were already started


        if (!file.progress.uploadStarted || !file.isRestored) {
          _this9.uppy.emit('upload-started', file);
        }

        return _this9.upload(file, current, total);
      });
      return settle(promises);
    }
    /**
     * @param {string[]} fileIDs
     */

  }, {
    key: "handleUpload",
    value: function handleUpload(fileIDs) {
      var _this10 = this;

      if (fileIDs.length === 0) {
        this.uppy.log('[Tus] No files to upload');
        return Promise.resolve();
      }

      if (this.opts.limit === 0) {
        this.uppy.log('[Tus] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/tus/#limit-0', 'warning');
      }

      this.uppy.log('[Tus] Uploading...');
      var filesToUpload = fileIDs.map(function (fileID) {
        return _this10.uppy.getFile(fileID);
      });
      return this.uploadFiles(filesToUpload).then(function () {
        return null;
      });
    }
  }, {
    key: "install",
    value: function install() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: true
        })
      });
      this.uppy.addUploader(this.handleUpload);
      this.uppy.on('reset-progress', this.handleResetProgress);
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      this.uppy.setState({
        capabilities: _objectSpread(_objectSpread({}, this.uppy.getState().capabilities), {}, {
          resumableUploads: false
        })
      });
      this.uppy.removeUploader(this.handleUpload);
    }
  }]);

  return Tus;
}(BasePlugin)), _class.VERSION = "2.2.2", _temp);